import React, { useState } from "react";
import { FaDollarSign, FaChair, FaUsers, FaImage } from "react-icons/fa";
import styles from "./ArenaUserDashboard.module.css";
import { Carousel } from "react-responsive-carousel";
import ImageModal from "../../common/FullScreenImageModal";

const FacilitySelection = ({ sport, facilities, onFacilitySelect }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);
  const [initialImageIndex, setInitialImageIndex] = useState(0);
  const [currentSlides, setCurrentSlides] = useState({});

  if (!facilities || facilities.length === 0) {
    return <div>No facilities available for this sport.</div>;
  }

  const handleImageClick = (e, images, imageIndex) => {
    e.preventDefault();
    e.stopPropagation();
    setSelectedImages(images);
    setInitialImageIndex(imageIndex);
    setModalOpen(true);
  };

  const closeImageModal = () => {
    setModalOpen(false);
    setSelectedImages([]);
    setInitialImageIndex(0);
  };

  return (
    <>
      <div className={styles.facilitiesGrid}>
        {facilities.map((facility) => (
          <div key={facility.id} className={styles.facilityCard}>
            {/* Facility Images */}

            {facility.images && facility.images.length > 0 && (
              <div className={styles.facilityImages}>
                <Carousel
                  showThumbs={false}
                  autoPlay={true}
                  showIndicators={false}
                  infiniteLoop={true}
                  interval={5000}
                  stopOnHover={false}
                  showStatus={false}
                  showArrows={false}
                  selectedItem={currentSlides[facility.id] || 0}
                  onChange={(slide) =>
                    setCurrentSlides((prev) => ({
                      ...prev,
                      [facility.id]: slide,
                    }))
                  }
                >
                  {facility.images.map((image, index) => (
                    <div
                      style={{ position: "relative" }}
                      key={index}
                      onClick={(e) =>
                        handleImageClick(e, facility.images, index)
                      }
                    >
                      <img
                        src={`data:image/jpeg;base64,${image}`}
                        alt={`${facility.about_facility} ${index + 1}`}
                        className={styles.facilityImage}
                        style={{ cursor: "pointer", pointerEvents: "auto" }}
                      />
                    </div>
                  ))}
                </Carousel>

                <div className={styles.customControlDots}>
                  {facility.images.slice(0, 3).map((_, index) => (
                    <span
                      key={index}
                      className={`${styles.customDot} ${
                        (currentSlides[facility.id] || 0) === index
                          ? styles.active
                          : ""
                      }`}
                      onClick={() =>
                        setCurrentSlides((prev) => ({
                          ...prev,
                          [facility.id]: index,
                        }))
                      }
                    />
                  ))}
                </div>
              </div>
            )}
            <div className={styles.facilityDetail}>
              <h3>
                {facility.sport_name}{" "}
                <div className={styles.facilityInfo}>
                  <p>
                    <FaChair /> Sitting Capacity:{" "}
                    <span>{facility.spectator_seating_capacity || "N/A"}</span>
                  </p>
                  <p>
                    <FaUsers /> Standing Capacity:{" "}
                    <span>{facility.spectator_standing_capacity || "N/A"}</span>
                  </p>
                </div>
              </h3>

              <p className={styles.extraFacility}>
                {facility.about_facility || "Unnamed Facility"}
              </p>
              <div className={styles.cardBottom}>
                <h5>Rs {facility.charge || "N/A"} /hr</h5>
                <button
                  className={styles.selectButton}
                  onClick={() => onFacilitySelect(facility)}
                >
                  Select
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Image Modal */}
      <ImageModal
        images={selectedImages}
        initialIndex={initialImageIndex}
        isOpen={modalOpen}
        onClose={closeImageModal}
        alt="Facility Image"
        isBase64={true}
      />
    </>
  );
};
export default FacilitySelection;
